var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "pickPendingMoveorder-report"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-tabs', [_c('b-tab', {
    staticClass: "show",
    attrs: {
      "title": _vm.$t('pickPendingMoveOrder.pickPending'),
      "active": ""
    },
    on: {
      "click": function($event) {
        _vm.loadOrderReport('allocated')
      }
    }
  }, [(_vm.orderStatus == 'allocated') ? _c('div', [_c('div', {
    staticClass: "card-headerfrmOrd"
  }, [(_vm.showSelectClient || _vm.showSelectWarehouse) ? _c('div', {
    staticClass: "form-group row"
  }, [(_vm.showSelectMerchant) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.merchant')) + " ")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "32px",
      "border-color": "#799497 !important"
    },
    attrs: {
      "left": "<i class='fa fa-group'></i>"
    }
  }, [_c('basic-select', {
    ref: "mrch_id",
    staticClass: "form-control",
    staticStyle: {
      "color": "rgb(20, 33, 44)",
      "padding": "8px",
      "padding-left": "13px",
      "border-radius": "0%"
    },
    attrs: {
      "id": "mrch_id",
      "options": _vm.listMerchantData1,
      "selected-option": _vm.item,
      "placeholder": _vm.$t('common.merchantPlaceholder')
    },
    on: {
      "select": _vm.onSelect
    },
    model: {
      value: (_vm.merchant),
      callback: function($$v) {
        _vm.merchant = $$v
      },
      expression: "merchant"
    }
  })], 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('common.orderNumber')) + " ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "movenoFlt",
      "placeholder": _vm.$t('common.orderNumberPlaceHolder')
    },
    model: {
      value: (_vm.movenoFlt),
      callback: function($$v) {
        _vm.movenoFlt = $$v
      },
      expression: "movenoFlt"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('warehouseRacks.rackType')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.racktype),
      expression: "racktype"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "racktype"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.racktype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('warehouseRacks.selectRackTypePlaceHolder')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Accept",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.accept')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Reject",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.reject')))])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('common.fromDate')) + " ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "format": "YYYY-MM-DD",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.fromDateFlt),
      callback: function($$v) {
        _vm.fromDateFlt = $$v
      },
      expression: "fromDateFlt"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('common.toDate')) + " ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "not-before": _vm.fromDateFlt,
      "format": "YYYY-MM-DD",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.toDateFlt),
      callback: function($$v) {
        _vm.toDateFlt = $$v
      },
      expression: "toDateFlt"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.getMoveOrderListSearch()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.$t('common.searchBtn')))]), _vm._v("\n                         "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetOrderSerach
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('common.resetBtn')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "25px"
    }
  }, [_c('div', {
    staticClass: "col-md-3 cardlistheader"
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('pickPendingMoveOrder.table.title')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('common.table.heading')) + " - " + _vm._s(this.formattedDate))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1.5 "
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy",
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('common.table.count')) + " - " + _vm._s(this.totalRows))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-0.5 cardlistheader"
  }, [_c('loader', {
    staticStyle: {
      "margin-right": "-400px"
    },
    attrs: {
      "isLoading": _vm.isLoadingforxls
    }
  })], 1), _vm._v(" "), (_vm.download && _vm.listOrderReportData.totalRows) ? _c('div', {
    staticClass: "col-md-0.5"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "-319px"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.Choosetype1(1)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.downloadBtn')))])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.listOrderReportData.totalRows) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "-200px"
    },
    attrs: {
      "title": _vm.$t('common.downloadCsv'),
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.getMoveOrderListReport(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])]) : _vm._e(), _vm._v(" "), (_vm.limitExeed && _vm.show && _vm.listOrderReportData.totalRows) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "-159px"
    },
    attrs: {
      "title": _vm.$t('common.downloadXls'),
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.getMoveOrderListReportXLS(3)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  })])]) : _vm._e(), _vm._v(" "), (!_vm.limitExeed && _vm.show && _vm.listOrderReportData.totalRows) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('download-excel', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "-159px"
    },
    attrs: {
      "before-generate": _vm.startDownload,
      "before-finish": _vm.finishDownload,
      "header": _vm.dataFilter2,
      "title": "Download Excel",
      "data": _vm.listReportDataforxls,
      "fields": _vm.csvFieldsForXls,
      "worksheet": "MyWorksheet",
      "name": _vm.reportname
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('pickPendingMoveOrder.table.columns.moveOrderId')) + " (" + _vm._s(this.totalRows) + ")")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('pickPendingMoveOrder.table.columns.totalSKU')) + " (" + _vm._s(_vm.listOrderReportData.totalsku) + ")")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('pickPendingMoveOrder.table.columns.totalQty')) + " (" + _vm._s(_vm.listOrderReportData.totalquantity) + ")")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('pickPendingMoveOrder.table.columns.moveDate')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('pickPendingMoveOrder.table.columns.rackType')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('pickPendingMoveOrder.table.columns.createdDate')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.assignedTo')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.assignedDate')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('pickPendingMoveOrder.table.columns.merchantName')))])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.listOrderReportData.result), function(data) {
    return _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', {
      staticStyle: {
        "color": "blue",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.viewRackDetails(data.moveorderid)
        }
      }
    }, [_vm._v(_vm._s(data.moveorderid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.totalitem))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.totalquantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.movedate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.racktype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.creationdate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.pickuserid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.assigneddate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.merchantname))])])
  }), _vm._v(" "), (_vm.listOrderReportData.length <= 0 || (_vm.listOrderReportData.result && _vm.listOrderReportData.result.length <= 0)) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "14",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noRecordFoundMsg')))])]) : _vm._e()], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.totalPage > 1 || _vm.listOrderReportData.result.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e()], 1)]) : _vm._e()]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": _vm.$t('pickPendingMoveOrder.putawayPending')
    },
    on: {
      "click": function($event) {
        _vm.loadOrderReport('picked')
      }
    }
  }, [(_vm.orderStatus == 'picked') ? _c('div', [_c('div', {
    staticClass: "card-headerfrmOrd"
  }, [(_vm.showSelectClient || _vm.showSelectWarehouse) ? _c('div', {
    staticClass: "form-group row"
  }, [(_vm.showSelectMerchant) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.merchant')) + " ")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "32px",
      "border-color": "#799497 !important"
    },
    attrs: {
      "left": "<i class='fa fa-group'></i>"
    }
  }, [_c('basic-select', {
    ref: "mrch_id",
    staticClass: "form-control",
    staticStyle: {
      "color": "rgb(20, 33, 44)"
    },
    attrs: {
      "id": "mrch_id",
      "options": _vm.listMerchantData1,
      "selected-option": _vm.item,
      "placeholder": _vm.$t('common.merchantPlaceholder')
    },
    on: {
      "select": _vm.onSelect
    },
    model: {
      value: (_vm.merchant),
      callback: function($$v) {
        _vm.merchant = $$v
      },
      expression: "merchant"
    }
  })], 1)], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('pickPendingMoveOrder.moveOrderNumber')) + " ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "movenoFlt",
      "placeholder": _vm.$t('common.orderNumberPlaceHolder')
    },
    model: {
      value: (_vm.movenoFlt),
      callback: function($$v) {
        _vm.movenoFlt = $$v
      },
      expression: "movenoFlt"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('warehouseRacks.rackType')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.racktype),
      expression: "racktype"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "racktype"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.racktype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('warehouseRacks.selectRackTypePlaceHolder')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Accept",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.accept')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Reject",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.reject')))])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('common.fromDate')) + " ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "format": "YYYY-MM-DD",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.fromDateFlt),
      callback: function($$v) {
        _vm.fromDateFlt = $$v
      },
      expression: "fromDateFlt"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('common.toDate')) + " ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "not-before": _vm.fromDateFlt,
      "format": "YYYY-MM-DD",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.toDateFlt),
      callback: function($$v) {
        _vm.toDateFlt = $$v
      },
      expression: "toDateFlt"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.getMoveOrderListSearch()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v("  " + _vm._s(_vm.$t('common.searchBtn')))]), _vm._v("\n                    "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetOrderSerach
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('common.resetBtn')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "25px"
    }
  }, [_c('div', {
    staticClass: "col-md-3 cardlistheader"
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "color": "black"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('pickPendingMoveOrder.table.title')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('common.table.heading')) + " - " + _vm._s(this.formattedDate))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1.5 "
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy",
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('common.table.count')) + " - " + _vm._s(this.totalRows))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-0.5 cardlistheader"
  }, [_c('loader', {
    staticStyle: {
      "margin-right": "-400px"
    },
    attrs: {
      "isLoading": _vm.isLoadingforxls
    }
  })], 1), _vm._v(" "), (_vm.download && _vm.listOrderReportData.totalRows) ? _c('div', {
    staticClass: "col-md-0.5"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "-319px"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.Choosetype2(1)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.downloadBtn')))])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.listOrderReportData.totalRows) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "-200px"
    },
    attrs: {
      "title": _vm.$t('common.downloadCsv'),
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.getMoveOrderListReport(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])]) : _vm._e(), _vm._v(" "), (_vm.limitExeed && _vm.show && _vm.listOrderReportData.totalRows) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "-159px"
    },
    attrs: {
      "title": _vm.$t('common.downloadXls'),
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.getMoveOrderListReportXLS(3)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  })])]) : _vm._e(), _vm._v(" "), (!_vm.limitExeed && _vm.show && _vm.listOrderReportData.totalRows) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('download-excel', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "-159px"
    },
    attrs: {
      "before-generate": _vm.startDownload,
      "before-finish": _vm.finishDownload,
      "header": _vm.dataFilter2,
      "title": _vm.$t('common.downloadXls'),
      "data": _vm.listReportDataforxls,
      "fields": _vm.csvFieldsForXls,
      "worksheet": "MyWorksheet",
      "name": _vm.reportname
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    attrs: {
      "id": "my-table2"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('pickPendingMoveOrder.table.columns.moveOrderId')) + " (" + _vm._s(this.totalRows) + ")")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('pickPendingMoveOrder.table.columns.totalSKU')) + " (" + _vm._s(_vm.listOrderReportData.totalsku) + ")")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('pickPendingMoveOrder.table.columns.totalQty')) + " (" + _vm._s(_vm.listOrderReportData.totalquantity) + ")")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('pickPendingMoveOrder.table.columns.moveDate')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('pickPendingMoveOrder.table.columns.rackType')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('pickPendingMoveOrder.table.columns.createdDate')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.boxId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.pickingDoneDate')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.lastModifiedDate')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.lastModifiedBy')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('pickPendingMoveOrder.table.columns.merchantName')))])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.listOrderReportData.result), function(data) {
    return _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', [_vm._v(_vm._s(data.moveorderid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.totalitem))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.totalquantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.movedate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.racktype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.creationdate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.boxid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.pickdonedate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.lastmodifieddate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.lastmodifiedby))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.merchantname))])])
  }), _vm._v(" "), ((_vm.listOrderReportData.result && _vm.listOrderReportData.result.length == 0) || _vm.listOrderReportData.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "13",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noRecordFoundMsg')))])]) : _vm._e()], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.totalPage > 1 || _vm.listOrderReportData.result.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e()], 1) : _vm._e()])], 1)], 1)]), _vm._v(" "), _c('b-modal', {
    staticClass: "alocationPopUp",
    attrs: {
      "size": "vlg",
      "title": _vm.$t('common.orderAllocRack')
    },
    model: {
      value: (_vm.showOrderAllocationRacks),
      callback: function($$v) {
        _vm.showOrderAllocationRacks = $$v
      },
      expression: "showOrderAllocationRacks"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [(_vm.allocationResultData.length > 0) ? _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('common.orderRackDetail')) + ": " + _vm._s(_vm.allocationResultData[0].moveorderid) + " ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.showOrderAllocationRacks = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.productId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('pickPendingMoveOrder.table.columns.qty')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.rackID')))])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.allocationResultData), function(allocation) {
    return _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', [_vm._v(_vm._s(allocation.productid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(allocation.qty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(allocation.rackid))])])
  }), _vm._v(" "), (_vm.allocationResultData.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noRecordFoundMsg')))])]) : _vm._e()], 2)])])])])], 1)], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-082c0d14", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-082c0d14","hasScoped":true}!./src/views/components/reports/pickPendingMoveorder/pickPendingMoveorder.component.html
// module id = 2033
// module chunks = 0